import React, { useEffect } from "react";

const KakaoLoginButtonV4 = () => {
  // 로딩 상태 제거 - 흰 화면만 표시
  const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

  const { Kakao } = window;

  const initKakao = () => {
    if (Kakao && !Kakao.isInitialized()) {
      try {
        Kakao.init(`6c54a190aec39267e878c6152a72a4c7`);
      } catch (error) {
        console.error('❌ 카카오 SDK 초기화 실패:', error);
      }
    }
  };

  useEffect(() => {
    initKakao();
  }, []);

  const kakaoLoginHandler = () => {
    // 환경 변수 검증
    if (!REDIRECT_URI) {
      console.error('❌ REDIRECT_URI가 설정되지 않았습니다');
      alert('로그인 설정 오류가 발생했습니다. 관리자에게 문의해주세요.');
      return;
    }

    // 카카오 SDK 초기화 확인
    if (!Kakao || !Kakao.Auth) {
      console.error('❌ 카카오 SDK가 로드되지 않았습니다');
      alert('카카오 로그인을 사용할 수 없습니다. 페이지를 새로고침해주세요.');
      return;
    }

    try {
      Kakao.Auth.authorize({
        redirectUri: REDIRECT_URI,
      });
    } catch (error) {
      console.error('❌ 카카오 로그인 요청 실패:', error);
      alert('로그인 요청 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };


  return (
    <div
      onClick={kakaoLoginHandler}
      style={{
        display: 'flex',
        padding: '14px 40px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '12px',
        border: '2px solid #000',
        background: '#FEE500',
        boxShadow: '4px 4px 0 0 #000',
        cursor: 'pointer',
        color: '#000',
        textAlign: 'center',
        fontFamily: 'Pretendard',
        fontSize: '17px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '22px',
        transition: 'all 0.1s ease',
        opacity: 1
      }}
      onMouseDown={(e) => {
        e.target.style.transform = 'translate(2px, 2px)';
        e.target.style.boxShadow = '2px 2px 0 0 #000';
      }}
      onMouseUp={(e) => {
        e.target.style.transform = 'translate(0, 0)';
        e.target.style.boxShadow = '4px 4px 0 0 #000';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translate(0, 0)';
        e.target.style.boxShadow = '4px 4px 0 0 #000';
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.98047 1.875C11.6932 1.875 13.2772 2.20833 14.7327 2.87498C16.1881 3.54164 17.3387 4.44816 18.1845 5.59453C19.0302 6.74086 19.4531 7.99129 19.4531 9.34578C19.4531 10.7002 19.0302 11.9524 18.1845 13.1023C17.3387 14.2522 16.1898 15.1605 14.7379 15.8271C13.286 16.4938 11.7002 16.8271 9.98047 16.8271C9.43777 16.8271 8.87742 16.7883 8.29949 16.7107C5.79035 18.4532 4.45477 19.335 4.29266 19.3562C4.21512 19.3844 4.14109 19.3809 4.07063 19.3456C4.04242 19.3245 4.02129 19.2962 4.00719 19.2609C3.99309 19.2257 3.98605 19.1939 3.98605 19.1657V19.1234C4.02836 18.8482 4.34902 17.7019 4.94812 15.6843C3.58784 15.0071 2.50771 14.1094 1.70775 12.9912C0.907793 11.8731 0.507812 10.6579 0.507812 9.34578C0.507812 7.99129 0.930699 6.74086 1.77647 5.59453C2.62225 4.44816 3.77285 3.54164 5.22828 2.87498C6.68371 2.20833 8.26777 1.875 9.98047 1.875Z" fill="black" fillOpacity="0.9" />
      </svg>
      카카오로 시작하기
    </div>
  );
};

export default KakaoLoginButtonV4;
